export const airlineIcon = {
    '0B': require('../libs/images/AirlineLogo/0B.gif'),
    '1AC': require('../libs/images/AirlineLogo/1AC.gif'),
    '1X': require('../libs/images/AirlineLogo/1X.gif'),
    '2I': require('../libs/images/AirlineLogo/2I.gif'),
    '2J': require('../libs/images/AirlineLogo/2J.gif'),
    '2K': require('../libs/images/AirlineLogo/2K.gif'),
    '2L': require('../libs/images/AirlineLogo/2L.gif'),
    '2M': require('../libs/images/AirlineLogo/2M.gif'),
    '2N': require('../libs/images/AirlineLogo/2N.gif'),
    '2T': require('../libs/images/AirlineLogo/2T.jpeg'),
    '2Z': require('../libs/images/AirlineLogo/2Z.gif'),
    '3E': require('../libs/images/AirlineLogo/3E.gif'),
    '3L': require('../libs/images/AirlineLogo/3L.gif'),
    '3M': require('../libs/images/AirlineLogo/3M.gif'),
    '3P': require('../libs/images/AirlineLogo/3P.gif'),
    '3S': require('../libs/images/AirlineLogo/3S.gif'),
    '3U': require('../libs/images/AirlineLogo/3U.gif'),
    '4M': require('../libs/images/AirlineLogo/4M.gif'),
    '4O': require('../libs/images/AirlineLogo/4O.gif'),
    '4R': require('../libs/images/AirlineLogo/4R.gif'),
    '4U': require('../libs/images/AirlineLogo/4U.gif'),
    '5H': require('../libs/images/AirlineLogo/5H.gif'),
    '5N': require('../libs/images/AirlineLogo/5N.gif'),
    '5Q': require('../libs/images/AirlineLogo/5Q.gif'),
    '5U': require('../libs/images/AirlineLogo/5U.gif'),
    '5W': require('../libs/images/AirlineLogo/5W.jpg'),
    '6C': require('../libs/images/AirlineLogo/6C.gif'),
    '6E': require('../libs/images/AirlineLogo/6E.gif'),
    '6H': require('../libs/images/AirlineLogo/6H.gif'),
    '7E': require('../libs/images/AirlineLogo/7E.gif'),
    '7F': require('../libs/images/AirlineLogo/7F.gif'),
    '7I': require('../libs/images/AirlineLogo/7I.gif'),
    '7J': require('../libs/images/AirlineLogo/7J.gif'),
    '7M': require('../libs/images/AirlineLogo/7M.gif'),
    '7R': require('../libs/images/AirlineLogo/7R.gif'),
    '7V': require('../libs/images/AirlineLogo/7V.gif'),
    '7W': require('../libs/images/AirlineLogo/7W.gif'),
    '8I': require('../libs/images/AirlineLogo/8I.gif'),
    '8M': require('../libs/images/AirlineLogo/8M.gif'),
    '8Q': require('../libs/images/AirlineLogo/8Q.gif'),
    '8R': require('../libs/images/AirlineLogo/8R.gif'),
    '8U': require('../libs/images/AirlineLogo/8U.gif'),
    '9H': require('../libs/images/AirlineLogo/9H.gif'),
    '9K': require('../libs/images/AirlineLogo/9K.gif'),
    '9N': require('../libs/images/AirlineLogo/9N.gif'),
    '9U': require('../libs/images/AirlineLogo/9U.gif'),
    '9w': require('../libs/images/AirlineLogo/9w.gif'),
    A3: require('../libs/images/AirlineLogo/A3.gif'),
    A4: require('../libs/images/AirlineLogo/A4.gif'),
    A5: require('../libs/images/AirlineLogo/A5.gif'),
    A9: require('../libs/images/AirlineLogo/A9.gif'),
    AA: require('../libs/images/AirlineLogo/AA.gif'),
    AB: require('../libs/images/AirlineLogo/AB.jpg'),
    AE: require('../libs/images/AirlineLogo/AE.gif'),
    AF: require('../libs/images/AirlineLogo/AF.gif'),
    AI: require('../libs/images/AirlineLogo/AI.png'),
    AK: require('../libs/images/AirlineLogo/AK.gif'),
    AM: require('../libs/images/AirlineLogo/AM.gif'),
    AR: require('../libs/images/AirlineLogo/AR.gif'),
    AS: require('../libs/images/AirlineLogo/AS.gif'),
    AT: require('../libs/images/AirlineLogo/AT.gif'),
    AV: require('../libs/images/AirlineLogo/AV.gif'),
    AW: require('../libs/images/AirlineLogo/AW.gif'),
    AY: require('../libs/images/AirlineLogo/AY.jpg'),
    AZ: require('../libs/images/AirlineLogo/AZ.gif'),
    B2: require('../libs/images/AirlineLogo/B2.gif'),
    B3: require('../libs/images/AirlineLogo/B3.jpg'),
    B5: require('../libs/images/AirlineLogo/B5.gif'),
    B6: require('../libs/images/AirlineLogo/B6.gif'),
    B7: require('../libs/images/AirlineLogo/B7.gif'),
    BA: require('../libs/images/AirlineLogo/BA.gif'),
    BB: require('../libs/images/AirlineLogo/BB.gif'),
    BE: require('../libs/images/AirlineLogo/BE.gif'),
    BH: require('../libs/images/AirlineLogo/BH.gif'),
    BJ: require('../libs/images/AirlineLogo/BJ.gif'),
    BP: require('../libs/images/AirlineLogo/BP.gif'),
    BPA: require('../libs/images/AirlineLogo/BPA.gif'),
    BT: require('../libs/images/AirlineLogo/BT.gif'),
    BV: require('../libs/images/AirlineLogo/BV.gif'),
    BW: require('../libs/images/AirlineLogo/BW.gif'),
    BX: require('../libs/images/AirlineLogo/BX.gif'),
    CO: require('../libs/images/AirlineLogo/CO.gif'),
    CU: require('../libs/images/AirlineLogo/CU.gif'),
    CX: require('../libs/images/AirlineLogo/CX.gif'),
    CY: require('../libs/images/AirlineLogo/CY.gif'),
    CZ: require('../libs/images/AirlineLogo/CZ.jpg'),
    D2: require('../libs/images/AirlineLogo/D2.gif'),
    D6: require('../libs/images/AirlineLogo/D6.gif'),
    D7: require('../libs/images/AirlineLogo/D7.gif'),
    DC: require('../libs/images/AirlineLogo/DC.gif'),
    DE: require('../libs/images/AirlineLogo/DE.gif'),
    DG: require('../libs/images/AirlineLogo/DG.jpg'),
    DL: require('../libs/images/AirlineLogo/DL.gif'),
    DN: require('../libs/images/AirlineLogo/DN.gif'),
    DV: require('../libs/images/AirlineLogo/DV.gif'),
    DX: require('../libs/images/AirlineLogo/DX.gif'),
    DY: require('../libs/images/AirlineLogo/DY.gif'),
    E7: require('../libs/images/AirlineLogo/E7.gif'),
    EI: require('../libs/images/AirlineLogo/EI.gif'),
    EK: require('../libs/images/AirlineLogo/EK.gif'),
    EL: require('../libs/images/AirlineLogo/EL.gif'),
    EQ: require('../libs/images/AirlineLogo/EQ.gif'),
    ET: require('../libs/images/AirlineLogo/ET.gif'),
    EY: require('../libs/images/AirlineLogo/EY.gif'),
    F2: require('../libs/images/AirlineLogo/F2.gif'),
    F7: require('../libs/images/AirlineLogo/F7.gif'),
    FB: require('../libs/images/AirlineLogo/FB.gif'),
    FD: require('../libs/images/AirlineLogo/FD.gif'),
    FI: require('../libs/images/AirlineLogo/FI.gif'),
    FN: require('../libs/images/AirlineLogo/FN.gif'),
    FR: require('../libs/images/AirlineLogo/FR.jpg'),
    FS: require('../libs/images/AirlineLogo/FS.gif'),
    FY: require('../libs/images/AirlineLogo/FY.gif'),
    FZ: require('../libs/images/AirlineLogo/FZ.gif'),
    G3: require('../libs/images/AirlineLogo/G3.gif'),
    G8: require('../libs/images/AirlineLogo/G8.png'),
    G9: require('../libs/images/AirlineLogo/G9.png'),
    GF: require('../libs/images/AirlineLogo/GF.gif'),
    GR: require('../libs/images/AirlineLogo/GR.gif'),
    H1: require('../libs/images/AirlineLogo/H1.gif'),
    H2: require('../libs/images/AirlineLogo/H2.gif'),
    HF: require('../libs/images/AirlineLogo/HF.gif'),
    HO: require('../libs/images/AirlineLogo/HO.gif'),
    HV: require('../libs/images/AirlineLogo/HV.gif'),
    HZ: require('../libs/images/AirlineLogo/HZ.gif'),
    I5: require('../libs/images/AirlineLogo/I5.jpg'),
    I7: require('../libs/images/AirlineLogo/I7.gif'),
    IB: require('../libs/images/AirlineLogo/IB.gif'),
    IC: require('../libs/images/AirlineLogo/IC.gif'),
    IE: require('../libs/images/AirlineLogo/IE.gif'),
    IG: require('../libs/images/AirlineLogo/IG.gif'),
    IT: require('../libs/images/AirlineLogo/IT.gif'),
    IX: require('../libs/images/AirlineLogo/IX.jpg'),
    IZ: require('../libs/images/AirlineLogo/IZ.gif'),
    J2: require('../libs/images/AirlineLogo/J2.gif'),
    J3: require('../libs/images/AirlineLogo/J3.gif'),
    J5: require('../libs/images/AirlineLogo/J5.gif'),
    J8: require('../libs/images/AirlineLogo/J8.gif'),
    JA: require('../libs/images/AirlineLogo/JA.gif'),
    JE: require('../libs/images/AirlineLogo/JE.gif'),
    JF: require('../libs/images/AirlineLogo/JF.jpg'),
    JQ: require('../libs/images/AirlineLogo/JQ.gif'),
    JU: require('../libs/images/AirlineLogo/JU.gif'),
    K2: require('../libs/images/AirlineLogo/K2.gif'),
    K5: require('../libs/images/AirlineLogo/K5.gif'),
    K6: require('../libs/images/AirlineLogo/K6.gif'),
    KA: require('../libs/images/AirlineLogo/KA.gif'),
    KK: require('../libs/images/AirlineLogo/KK.gif'),
    KL: require('../libs/images/AirlineLogo/KL.gif'),
    KM: require('../libs/images/AirlineLogo/KM.gif'),
    KR: require('../libs/images/AirlineLogo/KR.gif'),
    KU: require('../libs/images/AirlineLogo/KU.gif'),
    KX: require('../libs/images/AirlineLogo/KX.gif'),
    LB: require('../libs/images/AirlineLogo/LB.jpg'),
    LC: require('../libs/images/AirlineLogo/LC.gif'),
    LG: require('../libs/images/AirlineLogo/LG.gif'),
    LH: require('../libs/images/AirlineLogo/LH.gif'),
    LI: require('../libs/images/AirlineLogo/LI.gif'),
    LO: require('../libs/images/AirlineLogo/LO.gif'),
    LP: require('../libs/images/AirlineLogo/LP.gif'),
    LR: require('../libs/images/AirlineLogo/LR.gif'),
    LS: require('../libs/images/AirlineLogo/LS.gif'),
    LT: require('../libs/images/AirlineLogo/LT.gif'),
    LX: require('../libs/images/AirlineLogo/LX.gif'),
    M9: require('../libs/images/AirlineLogo/M9.gif'),
    ME: require('../libs/images/AirlineLogo/ME.gif'),
    MH: require('../libs/images/AirlineLogo/MH.gif'),
    MI: require('../libs/images/AirlineLogo/MI.gif'),
    MN: require('../libs/images/AirlineLogo/MN.gif'),
    MR: require('../libs/images/AirlineLogo/MR.gif'),
    multi: require('../libs/images/AirlineLogo/multi.gif'),
    MW: require('../libs/images/AirlineLogo/MW.gif'),
    MY: require('../libs/images/AirlineLogo/MY.gif'),
    NF: require('../libs/images/AirlineLogo/NF.gif'),
    NK: require('../libs/images/AirlineLogo/NK.gif'),
    nologo: require('../libs/images/AirlineLogo/nologo.gif'),
    NT: require('../libs/images/AirlineLogo/NT.gif'),
    NU: require('../libs/images/AirlineLogo/NU.gif'),
    O6: require('../libs/images/AirlineLogo/O6.gif'),
    OA: require('../libs/images/AirlineLogo/OA.gif'),
    OB: require('../libs/images/AirlineLogo/OB.gif'),
    OM: require('../libs/images/AirlineLogo/OM.gif'),
    OP: require('../libs/images/AirlineLogo/OP.jpg'),
    OR: require('../libs/images/AirlineLogo/OR.gif'),
    OS: require('../libs/images/AirlineLogo/OS.gif'),
    OU: require('../libs/images/AirlineLogo/OU.gif'),
    OV: require('../libs/images/AirlineLogo/OV.gif'),
    P0: require('../libs/images/AirlineLogo/P0.gif'),
    P6: require('../libs/images/AirlineLogo/P6.gif'),
    P9: require('../libs/images/AirlineLogo/P9.gif'),
    PD: require('../libs/images/AirlineLogo/PD.gif'),
    PG: require('../libs/images/AirlineLogo/PG.jpg'),
    PR: require('../libs/images/AirlineLogo/PR.png'),
    PX: require('../libs/images/AirlineLogo/PX.gif'),
    PY: require('../libs/images/AirlineLogo/PY.gif'),
    PZ: require('../libs/images/AirlineLogo/PZ.gif'),
    Q9: require('../libs/images/AirlineLogo/Q9.gif'),
    QC: require('../libs/images/AirlineLogo/QC.gif'),
    QF: require('../libs/images/AirlineLogo/QF.gif'),
    QH: require('../libs/images/AirlineLogo/QH.gif'),
    QR: require('../libs/images/AirlineLogo/QR.gif'),
    QS: require('../libs/images/AirlineLogo/QS.gif'),
    QV: require('../libs/images/AirlineLogo/QV.gif'),
    QZ: require('../libs/images/AirlineLogo/QZ.gif'),
    R2: require('../libs/images/AirlineLogo/R2.gif'),
    R3: require('../libs/images/AirlineLogo/R3.gif'),
    RA: require('../libs/images/AirlineLogo/RA.gif'),
    RO: require('../libs/images/AirlineLogo/RO.gif'),
    RQ: require('../libs/images/AirlineLogo/RQ.gif'),
    RX: require('../libs/images/AirlineLogo/RX.gif'),
    s2: require('../libs/images/AirlineLogo/s2.jpg'),
    S3: require('../libs/images/AirlineLogo/S3.gif'),
    S4: require('../libs/images/AirlineLogo/S4.gif'),
    S7: require('../libs/images/AirlineLogo/S7.gif'),
    SB: require('../libs/images/AirlineLogo/SB.gif'),
    SC: require('../libs/images/AirlineLogo/SC.gif'),
    SG: require('../libs/images/AirlineLogo/SG.png'),
    SI: require('../libs/images/AirlineLogo/SI.gif'),
    SN: require('../libs/images/AirlineLogo/SN.jpg'),
    SP: require('../libs/images/AirlineLogo/SP.gif'),
    SQ: require('../libs/images/AirlineLogo/SQ.gif'),
    SS: require('../libs/images/AirlineLogo/SS.gif'),
    ST: require('../libs/images/AirlineLogo/ST.gif'),
    SU: require('../libs/images/AirlineLogo/SU.gif'),
    SV: require('../libs/images/AirlineLogo/SV.png'),
    SW: require('../libs/images/AirlineLogo/SW.gif'),
    SX: require('../libs/images/AirlineLogo/SX.gif'),
    SY: require('../libs/images/AirlineLogo/SY.gif'),
    SZ: require('../libs/images/AirlineLogo/SZ.gif'),
    T5: require('../libs/images/AirlineLogo/T5.gif'),
    TA: require('../libs/images/AirlineLogo/TA.gif'),
    TB: require('../libs/images/AirlineLogo/TB.gif'),
    TC: require('../libs/images/AirlineLogo/TC.gif'),
    TF: require('../libs/images/AirlineLogo/TF.gif'),
    TG: require('../libs/images/AirlineLogo/TG.gif'),
    TJ: require('../libs/images/AirlineLogo/TJ.gif'),
    TK: require('../libs/images/AirlineLogo/TK.gif'),
    TM: require('../libs/images/AirlineLogo/TM.gif'),
    TN: require('../libs/images/AirlineLogo/TN.gif'),
    TR: require('../libs/images/AirlineLogo/TR.jpg'),
    TT: require('../libs/images/AirlineLogo/TT.jpg'),
    TU: require('../libs/images/AirlineLogo/TU.gif'),
    TZ: require('../libs/images/AirlineLogo/TZ.jpg'),
    U2: require('../libs/images/AirlineLogo/U2.jpg'),
    U6: require('../libs/images/AirlineLogo/U6.gif'),
    UA: require('../libs/images/AirlineLogo/UA.gif'),
    UI: require('../libs/images/AirlineLogo/UI.gif'),
    UK: require('../libs/images/AirlineLogo/UK.png'),
    UL: require('../libs/images/AirlineLogo/UL.gif'),
    UM: require('../libs/images/AirlineLogo/UM.gif'),
    UN: require('../libs/images/AirlineLogo/UN.gif'),
    UO: require('../libs/images/AirlineLogo/UO.gif'),
    UP: require('../libs/images/AirlineLogo/UP.gif'),
    UT: require('../libs/images/AirlineLogo/UT.gif'),
    V0: require('../libs/images/AirlineLogo/V0.gif'),
    V2: require('../libs/images/AirlineLogo/V2.gif'),
    V3: require('../libs/images/AirlineLogo/V3.gif'),
    V4: require('../libs/images/AirlineLogo/V4.gif'),
    V7: require('../libs/images/AirlineLogo/V7.gif'),
    VA: require('../libs/images/AirlineLogo/VA.gif'),
    VJ: require('../libs/images/AirlineLogo/VJ.gif'),
    VL: require('../libs/images/AirlineLogo/VL.gif'),
    VR: require('../libs/images/AirlineLogo/VR.gif'),
    VS: require('../libs/images/AirlineLogo/VS.gif'),
    VW: require('../libs/images/AirlineLogo/VW.gif'),
    VX: require('../libs/images/AirlineLogo/VX.gif'),
    VY: require('../libs/images/AirlineLogo/VY.gif'),
    W3: require('../libs/images/AirlineLogo/W3.gif'),
    W4: require('../libs/images/AirlineLogo/W4.gif'),
    W5: require('../libs/images/AirlineLogo/W5.gif'),
    W9: require('../libs/images/AirlineLogo/W9.gif'),
    WB: require('../libs/images/AirlineLogo/WB.gif'),
    WM: require('../libs/images/AirlineLogo/WM.gif'),
    wordspan: require('../libs/images/AirlineLogo/wordspan.gif'),
    WS: require('../libs/images/AirlineLogo/WS.gif'),
    WV: require('../libs/images/AirlineLogo/WV.jpg'),
    X3: require('../libs/images/AirlineLogo/X3.gif'),
    X7: require('../libs/images/AirlineLogo/X7.gif'),
    XC: require('../libs/images/AirlineLogo/XC.gif'),
    XG: require('../libs/images/AirlineLogo/XG.gif'),
    XJ: require('../libs/images/AirlineLogo/XJ.gif'),
    XL: require('../libs/images/AirlineLogo/XL.gif'),
    XQ: require('../libs/images/AirlineLogo/XQ.gif'),
    xv: require('../libs/images/AirlineLogo/xv.gif'),
    Y4: require('../libs/images/AirlineLogo/Y4.png'),
    Y7: require('../libs/images/AirlineLogo/Y7.gif'),
    YC: require('../libs/images/AirlineLogo/YC.gif'),
    YK: require('../libs/images/AirlineLogo/YK.gif'),
    YM: require('../libs/images/AirlineLogo/YM.gif'),
    YV: require('../libs/images/AirlineLogo/YV.gif'),
    Z2: require('../libs/images/AirlineLogo/Z2.gif'),
    Z5: require('../libs/images/AirlineLogo/Z5.gif'),
    Z6: require('../libs/images/AirlineLogo/Z6.gif'),
    Z7: require('../libs/images/AirlineLogo/Z7.gif'),
    ZA: require('../libs/images/AirlineLogo/ZA.gif'),
    ZG: require('../libs/images/AirlineLogo/ZG.gif'),
    ZH: require('../libs/images/AirlineLogo/ZH.gif'),
    ZO: require('../libs/images/AirlineLogo/ZO.jpg'),
    ZS: require('../libs/images/AirlineLogo/ZS.jpg'),
  };
  